import React, { useEffect, useState, CSSProperties } from "react";
import "./TagComponent.css";

const TagComponent = ({
  tag,
  isSelected,
  onClick,
  tagsDefaultColors,
  onMouseEnter,
  onMouseLeave,
  tagsCounts = {},
  needCount = false,
}) => {
  const [tagColor, setTagColor] = useState(
    tag.color || (tagsDefaultColors && tagsDefaultColors[tag.id])
  );

  const tagColorClass = {
    "--tag-color": tagColor,
    "--tag-fill": `color-mix(in srgb, ${tagColor} 15%, transparent)`,
    "--tag-ink": "#12151d",
  };

  useEffect(() => {
    if (!tagColor) {
      setTagColor(tagsDefaultColors[tag.id]);
    }
  }, [Object.keys(tagsDefaultColors).length]);

  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`tag-block`}
      style={{ ...tagColorClass }}
      onClick={onClick}
    >
      <span className="tag__bg" />
      <div>
        <span className="tag__label" style={{ ...tagColorClass }}>
          {tag.name}
        </span>
        {needCount && tagsCounts[tag.id] && (
          <span
            className="tag__label"
            style={{ ...tagColorClass, opacity: 0.3 }}
          >
            {` ${tagsCounts[tag.id]}`}
          </span>
        )}
      </div>
    </div>
  );
};

export default TagComponent;
